import Pikaday from 'pikaday';

const html5Supported = (function () {
  const features = {};
  const input = document.createElement('input');

  features.placeholder = 'placeholder' in input;

  const inputTypes = ['email', 'url', 'tel', 'number', 'range', 'date'];

  $.each(inputTypes, (index, value) => {
    input.setAttribute('type', value);
    features[value] = input.type !== 'text';
  });

  return features;
})();

function overridecf7datepicker() {
  if (!html5Supported.date) {
    const datePicker = document.querySelectorAll('input[type="date"]');

    if (datePicker.length > 0) {
      datePicker.forEach((dateElement) => {
        new Pikaday({
          field: dateElement,
          format: 'DD/MM/YYYY',
        });
      });
    }
  }
}


export function init() {
  overridecf7datepicker();
}
